import { topicsAction } from './topic-slice'
import { toCApi } from '../utils'
import { throwApiError } from '../components/lms-shared/store/error-handling-actions'
import { ActivityTypeEnum } from '../models/ActivityTypeEnum'

export const fetchTopicsData = (studyGroupId, application, includeHasSubmissions, uiData) => {

  return async (dispatch, getState) => {

    const state = getState();
    const texts = state.translate?.texts;
    const courses = state.courses?.courses;
    const studyGroup = courses.find(c => c.id === studyGroupId);

    dispatch(topicsAction.init({ lessonByTopic: null, topics: null, studyGroup: null }))
    const lessonesListType = uiData[application].lessonesListType;
    if (studyGroup) {
      toCApi.toCFilterRangePost({ toCRangeFilter: { studyGroupId, includeHasSubmissions: includeHasSubmissions } }, (error, resdata, response) => {
        if (error) {
          dispatch(throwApiError({ userMessage: texts.MessageTitleTocFilterRange, error: error, statusCode: response?.statusCode, message: "toCFilterRangePost " + error.message, level: 1, component: "topic-actions", line: 32 }))
        }
        else {
          let topicsListTemp = [[], [], []]
          let allTopicsList = { [lessonesListType[0]]: [], [lessonesListType[1]]: [], [lessonesListType[2]]: [] }
          let indexOnMap;
          let lessonIndex = 1

          function createtopicsList(child, typeLessons, index, lengthParant, indexChild) {
            let flag = false
            if (child.isLesson == true) {
              if (indexChild > lengthParant - 5) {
                if (!uiData.aiCourses?.list?.includes(studyGroupId))
                  child.indexOnMap = indexOnMap++;
                else
                  child.indexOnMap = indexChild;
              }
              child.index = lessonIndex++;
              if (!topicsListTemp[typeLessons][index])
                topicsListTemp[typeLessons][index] = []
              const finalAssessment = child.assessments?.find(a => ActivityTypeEnum[a.activityType] == ActivityTypeEnum.Final);
              if (finalAssessment?.dueDate) {
                child.isLate = new Date(finalAssessment.dueDate) < new Date(finalAssessment.submission?.submittedDate ? finalAssessment.submission.submittedDate : new Date())
              }
              child.lessonType = lessonesListType[typeLessons]
              topicsListTemp[typeLessons][index].push(child)
              flag = true
              child.ClientDate = new Date()
            }
            else {
              if (child.children.length > 0 && flag === false)
                child.children.map((l, indexChild) => { createtopicsList(l, typeLessons, index, child.children.length, indexChild + 1) })
            }
          }

          response.body && response.body.map((y, index) => {
            indexOnMap = 1
            return y.children.map((y2, index2) => createtopicsList(y2, index, index2, response.body.length, 0))
          })


          response.body.map((z, index) =>
            z.children.map((z1, index1) =>
              allTopicsList[lessonesListType[index]]?.push({ lessons: topicsListTemp[index][index1], tag: { id: z1.id, name: z1.name } })))

          dispatch(topicsAction.init({ lessonByTopic: allTopicsList, topics: response.body, studyGroup }))
        }
      })
    }
  }
}